import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getCampaigns } from "./api";
import { moduleName } from "./common";
import { CampaignTabs } from "./types";
export const initialState = {
    quarterSelected: undefined,
    selectedCampaignIds: {},
    selectedTab: CampaignTabs.Summary
};
const slice = createSlice({
    initialState,
    name: moduleName,
    reducers: {
        setSelectedCampaign(state, action) {
            if (state.quarterSelected) {
                state.selectedCampaignIds[state.quarterSelected] = action.payload;
            }
        },
        updateQuarterSelected(state, action) {
            state.quarterSelected = action.payload;
        },
        updateSelectedTab(state, action) {
            state.selectedTab = action.payload;
        }
    }
});
export const setQuarterSelected = createAsyncThunk(`${moduleName}/setQuarterSelected`, (asOfDate, { dispatch }) => {
    if (asOfDate !== undefined && asOfDate !== null) {
        dispatch(getCampaigns.initiate({ asOfDate: asOfDate.toDateString() }));
        dispatch(slice.actions.updateQuarterSelected(asOfDate.toDateString()));
    }
});
export const campaignsReducers = slice.reducer;
export const { setSelectedCampaign, updateSelectedTab, updateQuarterSelected } = slice.actions;
